import { SelectionValue } from "features/shared/types/select";
import React from "react";
import styled from "styled-components";
import CustomSelect from "../../customSelect";

interface Props<T> {
    value: T;
    readOnlyMode?: boolean;
    selectionOptions: SelectionValue<T>[];
    onSelectHandler: (value: T) => void;
}

const SelectInput = <T,>({
    value,
    readOnlyMode,
    selectionOptions,
    onSelectHandler,
}: Props<T>) => {
    return (
        <StyledSelectContainer>
            <CustomSelect
                options={selectionOptions}
                onChangeHandler={onSelectHandler}
                initialValue={{
                    display: selectionOptions.find(
                        (selectionOption) => selectionOption.value === value
                    )?.display as string,
                    value,
                }}
                disabled={readOnlyMode}
            />
        </StyledSelectContainer>
    );
};

const StyledSelectContainer = styled.div`
    font-size: 1rem;
    height: 2rem;

    & > * {
        height: 100%;
    }
`;

export default SelectInput;
